import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";


import MessageFeedback from '../../components/common/messageFeedback/MessageFeedback';
import Personalization from '../../components/common/personalization/Personalization';
import LoadingSpinner from '../../components/common/spinner/LoadingSpinner';
import useLoadSubscriber from "../../hooks/useLoadSubscriber";


const NewSubscribers = () => {
  const intl = useIntl()

  const { idList, listGuid, idUser, userHash } = useParams()

  const { status, data, errorType } = useLoadSubscriber({
    idList: Number.parseInt(idList),
    listGuid,
    idUser: Number.parseInt(idUser),
    userHash
  })

  return (
    <>


      {status === 'error' && (
        <div className="[ #MU-V8 gray_container ] [ #MU-V9 frontend-wrapper-xl ]">
          <MessageFeedback kind='error'>
            {errorType === 'wrong-params'
              ? intl.formatMessage({ id: 'Load.Common.ParameterValueError' })
              : intl.formatMessage({ id: 'Load.Alerts.ErrorGeneric' })
            }

          </MessageFeedback>
        </div>)}

      {status === 'loading' &&
        <div className='frontend-wrapper'>
          <LoadingSpinner />
        </div>
      }


      {status === 'ready' && (
        <>
          <Personalization idList={idList} showLogo applyCustomCSS />

          <div className="[ #MU-V9 frontend-wrapper ]">
            <div className="[ #MU-V8 container mobile ][ #MU-V9 frontend-box frontend-row ]">
              <div className="[ #MU-V9 frontend-row-sm ]">
                <h1 className="[ #MU-V8 title ]">{intl.formatMessage({ id: 'Load.NewSubscribers.Title' })}</h1>
              </div>

              <div className="[ #MU-V8 text_container_noborder_mini text_no_bold font_size_13 ] [  #MU-V9 frontend-main-text frontend-row-xx-sm ]">
                {intl.formatMessage({ id: 'Load.NewSubscribers.Subtitle' })}
              </div>

              <ul id="recipient-data" className="[ #MU-V8 formstandard ] [ #MU-V9  frontend-row-sm ] ">
                <li className="[ #MU-V8 onecolumn ] [  #MU-V9 frontend-row-xx-sm ]">
                  <label className="[ #MU-V9 frontend-text-bold frontend-p-right ]">{intl.formatMessage({ id: 'Load.NewSubscribers.LabelEmail' })}</label>
                  <span id="emailaddress" runat="server">{data.email}</span>
                </li>
                <li className="[ #MU-V8 onecolumn ] [  #MU-V9 frontend-row-xx-sm ]">
                  <label className="[ #MU-V9 frontend-text-bold frontend-p-right ]" htmlFor="telephonprefix">{intl.formatMessage({ id: 'Load.NewSubscribers.LabelPhonePrefix' })}</label>
                  <span id="telephonprefix" runat="server">{data.mobilePrefix}</span>
                </li>
                <li className="[ #MU-V8 onecolumn ] [  #MU-V9 frontend-row-xx-sm ]">
                  <label className="[ #MU-V9 frontend-text-bold frontend-p-right ]" htmlFor="telephonnumber">{intl.formatMessage({ id: 'Load.NewSubscribers.LabelPhoneNumber' })}</label>
                  <span id="telephonnumber" runat="server">{data.mobileNumber}</span>
                </li>
              </ul>

              <div className="[ #MU-V9  frontend-row-x-sm ]">
                <h2 className="[ #MU-V8 data-box-title ]">{intl.formatMessage({ id: 'Load.NewSubscribers.DynamicFields' })}</h2>
              </div>

              <div className="data-box">
                <ul className="[ #MU-V8 formstandard  ] [ #MU-V9 frontend-row_reset frontend-row-sm ]">
                  {data.dynamicFields.map(df =>
                    <li className="[ #MU-V8 onecolumn ] [ #MU-V9  frontend-row-xx-sm ]" key={df.Key}>
                      <strong className="[ #MU-V9 frontend-text-bold frontend-p-right ]">{df.Key}</strong>
                      {df.Value}
                    </li>)}
                </ul>
              </div>

              <div className="[ #MU-V8 data-box ] [ #MU-V9 frontend-row-big ]">
                <div className="[ #MU-V9  frontend-row-xx-sm ]">
                  <h2 className="[ #MU-V8 data-box-title ]">{intl.formatMessage({ id: 'Load.NewSubscribers.SubscriberGroups' })}</h2>
                </div>

                <ul id="gruppiDiv" className="[ #MU-V8 formstandard ] [ #MU-V9 frontend-elenco-puntato ]">
                  {data.groups.map((g, idx) => (
                    <li key={idx} className="onecolumn">
                      <label htmlFor="campo{idx}">
                        {g}

                      </label>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="[ #MU-V8 text_container_noborder_mini text_no_bold font_size_13 ] [ #MU-V9 frontend-note frontend-row-sm ]">
              {intl.formatMessage({ id: 'Load.NewSubscribers.Notes' }, {
                strong: chunks => <strong>{chunks}</strong>
              })}
            </div>

          </div >
        </>)
      }
    </>)
}

export default NewSubscribers